import * as _ from 'underscore';
import * as $ from 'jquery';
import * as React from 'react';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { ICellStyle, ISize, IWidth } from './Interfaces';
import { IValuesCollection } from '../ts/appTheme';
import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';

import {
    TimeValueFormat,
    convertTimeValueAsDateToString,
    isTypeOfDateOrDatetime,
    isTypeOfTime
} from './DateTimeFunctions';

import { COLOR_MAP_UNDEF_KEY, COLOR_MAP_UNDEF_COLOR, ATTRIBUTE_TYPES } from './ConfigurationConstants';

import { MappingUtilities } from './MappingUtilities';
import { ATTRIBUTE_SEPARATOR } from '../../../pdc-platform/src/ts/stores/EntityModelsStore';

import { getPalette } from 'devextreme/viz/palette';

const Globalize = require('pdc-platform-Globalize');
const Hogan = require('hogan.js');
//const Mustache = require('mustache-for-chromeapps');

declare var Color: any;

export function sortBy<T>(list: _.List<T>, propertyName: string, caseSensitive = false): T[] {
    if (caseSensitive === true) {
        return _.sortBy(list, propertyName);
    } else {
        return _.sortBy(list, (item) => {
            const value = item[propertyName];

            return value != null ? value.toLowerCase() : value;
        });
    }
}

export function sortByName<T extends { name: string }>(list: _.List<T>, caseSensitive = false): T[] {
    return sortBy<T>(list, 'name', caseSensitive);
}

export function encodeHtml(input: string) {
    return input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

let _newID = 0;

export function getNewID() {
    const dateID = new Date().valueOf();

    if (dateID > _newID) {
        _newID = dateID;
    } else {
        _newID++;
    }

    //console.log('NewID: ' + _newID);
    return _newID;
}

// Generates a not globaly unique ID.
// Is useful when the number must be not that big as from getNewID().
export function getRandomID(min = 1000000, max = 2147483648) {
    return Math.floor(Math.random() * (max - min) + min);
}

// CID for virtual Workspaces must be negative.
// Performance Statistics WS does not support ID of bigInt type.
export function getVirtualWorkspaceID() {
    return -getRandomID();
}

export function addIDToItems(collection: { id?: number }[]) {
    if (collection != null && collection.length > 0) {
        _.each(collection, (item) => {
            if (item.id == null) {
                item.id = getNewID();
            }
        });
    }
}

export function renewIDsAndCIDs(element: any) {
    if (element != null && typeof element === 'object') {
        if (element.cid != null && element.cid === element.id) {
            const newID = getNewID();

            element.cid = newID;
            element.id = newID;
        }

        Object.keys(element).forEach((key) => {
            //this.renewIDsAndCIDs(element[key]);
            renewIDsAndCIDs(element[key]); //LL: 22.07.24
        });
    }
}

export function deleteIDFromItems(collection: { id?: number }[]) {
    if (collection != null && collection.length > 0) {
        _.each(collection, (item) => {
            if (item.id != null) {
                delete item.id;
            }
        });
    }
    return collection;
}

export function showNotification(
    severity: 'warning' | 'success' | 'fail',
    text: string,
    manualClose: boolean = true,
    details: string = '',
    glob?: IGlob
) {
    if (glob == null) {
        glob = window['pdc'].platform.glob;
    }

    glob.AppActions.notification(severity, text, {
        manualDestroy: manualClose,
        details: details
    });
}

export function getPopoverStyle(
    offset: { top?: number; left?: number },
    popoverSize: ISize
): {
    side: string;
    top: number;
    left: number;
    arrowTop: string;
} {
    const windowWidth = $(window).width();
    const windowHeight = $(window).height();
    const arrowGap = 16;
    const popoverHeight = typeof popoverSize.height === 'string' ? parseFloat(popoverSize.height) : popoverSize.height;
    const popoverWidth = typeof popoverSize.width === 'string' ? parseFloat(popoverSize.width) : popoverSize.width;

    let side = 'right'; //"bs-popover-right";
    let left = offset.left + arrowGap - 10;
    let top = offset.top - popoverHeight / 2 - 4;
    let arrow_top = '49%';

    if (popoverWidth + offset.left + arrowGap > windowWidth) {
        side = 'left'; //"bs-popover-left";
        left = offset.left - popoverWidth;
    }

    if (top < 0) {
        arrow_top = popoverHeight / 2 + top + 'px';
        top = 0;
    } else if (windowHeight - offset.top < popoverHeight / 2) {
        top = windowHeight - popoverHeight;
        arrow_top = popoverHeight - (windowHeight - offset.top) + 'px';
    }

    return {
        side: side,
        top: top,
        left: left,
        arrowTop: arrow_top
    };
}

//LL: merges internal arrays of objects that have key "name"
export function mergeRecursive(...par) {
    // _mergeRecursive does the actual job with two arguments.
    var _mergeRecursive = function (dst, src) {
        //if ( isDOMNode(src) || typeof src!=='object' || src===null) {
        //    return dst;
        //}
        //LL: my: without isDOMNode:
        if (typeof src !== 'object' || src === null) {
            return dst;
        }

        //LL: 06.10.20: note: option "entities-model-color-mapping" is array with no "name"s
        //     it has attribute and dataSourceID;  name can be composed by:
        //     let newKey = itemOne.attribute + '→' + itemOne.dataSourceID.toString();

        //LL:  objects in arrays are merged if they have "name" key
        for (var p in src) {
            if ($.isArray(src[p])) {
                //LL: 06.10.20:
                let isEntityColorMapping = p === 'entities-model-color-mapping';
                //if (isEntityColorMapping) {
                //    console.log("isEntityColorMapping");
                //}
                if (isEntityColorMapping) {
                    $.each(dst[p], function (i, del) {
                        if (del.name == null) {
                            del.name = del.attribute + '→' + del.dataSourceID.toString();
                        }
                    });
                    $.each(src[p], function (i, del) {
                        if (del.name == null) {
                            del.name = del.attribute + '→' + del.dataSourceID.toString();
                        }
                    });
                }

                if (!dst[p]) {
                    dst[p] = src[p];
                    continue;
                }

                //LL: my: try to set "inherited" when there is "name":   //LL: does not work, set "inherited" in merger
                $.each(dst[p], function (i, del) {
                    if (del.name) {
                        del.inherited = true;
                    }
                });

                $.merge(dst[p], src[p]);

                let dupes = {};
                let singles = [];

                $.each(dst[p], function (i, el) {
                    const dupe = dupes[el.name];

                    if (dupe > -1 && el.name) {
                        const single = singles[dupe];

                        if (single != null) {
                            //  <============== !!!   name !
                            $.extend(true, single, el); //LL: 08.10.20: add "true"
                            //LL: my: try "inherited": //LL: does not work, set "inherited" in merger
                            if (el.inherited !== true) {
                                delete single.inherited;
                            }
                        }
                    } else {
                        if (el.name) {
                            dupes[el.name] = i;
                        }
                        singles.push(el);
                    }
                });

                dst[p] = singles;

                continue;
            }

            if (!src.hasOwnProperty(p)) {
                continue;
            }

            if (src[p] === undefined) {
                continue;
            }

            if (typeof src[p] !== 'object' || src[p] === null || p === 'widget-gauge-palette-color') {
                // IL 86343: Gauge widget. Widget theme Palette="Custom Color" is always override by WS theme = BUG->  || $.isArray(src[p]) || p==="widget-gauge-palette-color"
                dst[p] = src[p];
            } else if (typeof dst[p] !== 'object' || dst[p] === null) {
                dst[p] = _mergeRecursive(src[p].constructor === Array ? [] : {}, src[p]);
            } else {
                _mergeRecursive(dst[p], src[p]);
            }
        }
        return dst;
    };

    // Loop through arguments and merge them into the first argument.
    let out = $.extend(true, {}, arguments[0]); //LL: 06.10.20  make copy

    if (typeof out !== 'object' || out === null) {
        return out;
    }

    for (var i = 1, il = arguments.length; i < il; i++) {
        _mergeRecursive(out, $.extend(true, {}, arguments[i])); //LL: my: make copy, sources are broken somewhere
    }

    //LL: 06.10.20: rem "name":
    for (var p in out) {
        let isEntityColorMapping = p === 'entities-model-color-mapping';
        if (isEntityColorMapping) {
            $.each(out[p], function (i, del) {
                delete del.name;
            });
        }
    }

    return out;
}

const ultimateDark = '#000000';
const ultimateLight = '#FFFFFF';

export function getContrastColor(color) {
    if (Color(color).dark()) {
        return ultimateLight;
    } else {
        return ultimateDark;
    }
}

export function isDark(color) {
    if (Color(color).dark()) {
        return true;
    } else {
        return false;
    }
}

//IL: Get light or darker color. Percent is from 100 to -100
export function shaderColor(color, percent) {
    var num = parseInt(color.slice(1), 16);
    var amt = Math.round(2.55 * percent);
    var R = (num >> 16) + amt;
    var G = ((num >> 8) & 0x00ff) + amt;
    var B = (num & 0x0000ff) + amt;
    var new_color =
        '#' +
        (
            0x1000000 +
            (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
            (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
            (B < 255 ? (B < 1 ? 0 : B) : 255)
        )
            .toString(16)
            .slice(1);
    return new_color;
}

//LL: 18.11.19: add dataType?, see ColorHexWrapper.evaluateColor for discrete
//LL: 14.11.19:  OE's function, only for Numbers
export function getDevExpressPaletteColors(paletteName) {
    //if (paletteName == null) paletteName = "default";
    //LL:  DevExpress 18.1.5:
    //    The ""palette"" option does not accept the "Default" value since v.18.1. Use the "Office" value instead
    //    Added:  'Material', 'Office'    Default Value: 'Material'
    if (paletteName == null || paletteName === 'default') {
        paletteName = 'Office';
    }

    //if (
    //    DevExpress != null &&
    //    DevExpress.viz != null &&
    //    DevExpress.viz.getPalette != null
    //) {
    //    let pal = DevExpress.viz.getPalette(paletteName);
    //    if (pal != null) {
    //        return pal.simpleSet;
    //    }
    //}
    //LL: 31.01.24 DevExpress.viz.getPalette -> getPalette from "devextreme/viz/palette"
    if (getPalette != null) {
        let pal = getPalette(paletteName);
        if (pal != null) {
            return pal.simpleSet;
        }
    }
    return null;
}

//LL: ColorHexWrapper - convert Color <=> Hex

export class ColorHexWrapper {
    //  http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb

    private static componentToHex(c) {
        // 'c' - numeric ~~ 5e
        const hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    public static rgbToHex(r, g, b) {
        // r, g, b - numeric ~~ 5e
        return (
            '#' +
            ColorHexWrapper.componentToHex(r) +
            ColorHexWrapper.componentToHex(g) +
            ColorHexWrapper.componentToHex(b)
        );
    }

    //LL:  alert( rgbToHex(0, 51, 255) ); // #0033ff

    public static hexToRgb(hex) {
        // 'hex' - "#0033ff"
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : null;
    }

    //LL: 20.05.19: add dataType
    //LL: 08.10.18:  from ColorMappingForNumericField
    public static evaluateColor(value, minValue, maxValue, cmfnObj, dataType?) {
        //   cmfnObj - ColorMappingForNumericField
        if (cmfnObj == null) {
            return null;
        }

        //LL: 17.05.19: discrete
        let isDiscrete = cmfnObj.mapping === 'discrete' || cmfnObj.mapping === 'Discrete';

        if (value == null) {
            if (isDiscrete) {
                if (cmfnObj.colorIntervals != null && cmfnObj.colorIntervals.nullMappedValue != null) {
                    return cmfnObj.colorIntervals.nullMappedValue;
                } else {
                    return null;
                }
            } else {
                if (cmfnObj.nullColor != null) {
                    return cmfnObj.nullColor;
                } else {
                    return cmfnObj.startColor;
                }
            }
        }

        if (isDiscrete) {
            // check value type,    cmfnObj.dataType
            let wrongDataType = false;
            let dataTypeInObj = cmfnObj.dataType != null ? cmfnObj.dataType : 'i';
            if (dataTypeInObj != null && dataType != null) {
                switch (dataType) {
                    case 'i':
                    case 'r':
                    case 'number':
                        wrongDataType = !(dataTypeInObj === 'i' || dataTypeInObj === 'r' || dataTypeInObj === 'number');
                        break;
                    case 'time':
                        wrongDataType = dataTypeInObj !== 'time';
                        break;
                    case 'date':
                    case 'datetime':
                        wrongDataType = !(dataTypeInObj === 'date' || dataTypeInObj === 'datetime');
                        break;
                    case 'b': // no in ColorMapping ?
                        wrongDataType = !(dataTypeInObj === 'b' || dataTypeInObj === 'boolean');
                        break;
                    case 's':
                        wrongDataType = !(dataTypeInObj === 's' || dataTypeInObj === 'string');
                        break;
                    default:
                        // 'e'
                        wrongDataType = true;
                }
            }
            if (wrongDataType) {
                console.log(
                    'evaluateColor: wrong data types for Discrete, dataType = ' +
                        dataType +
                        ' dataTypeInObj = ' +
                        dataTypeInObj
                );
                //LL:   Message  or  return ERROR ???
                return null;
            }

            let colorIntervals = cmfnObj.colorIntervals;

            if (cmfnObj.dataType === 'boolean') {
                if (value === true) {
                    if (colorIntervals != null && colorIntervals.trueMappedValue != null) {
                        return colorIntervals.trueMappedValue;
                    }
                }
                if (value === false) {
                    if (colorIntervals != null && colorIntervals.falseMappedValue != null) {
                        return colorIntervals.falseMappedValue;
                    }
                }
            }

            if (colorIntervals == null || colorIntervals.labels == null || colorIntervals.labels.length === 0) {
                return null;
            }

            //LL: 28.05.19:
            //  if dataTypeInObj is date/datetime, values are date-strings ("2012-01-27"),
            //  but "value" can be date (when called in Grid, for example) or string
            //LL: use here "dataTypeInObj", not "dataType", because the last can be null
            const stdCulture = 'en'; //LL: 25.03.20:   time format is hh:mm:ss
            let valueString = value;

            if (isTypeOfDateOrDatetime(dataTypeInObj)) {
                if (typeof value !== 'string') {
                    valueString = Globalize(stdCulture).formatDate(value, {
                        raw: TimeValueFormat
                    }); // 'yyyy-MM-ddTHH:mm:ss'
                }
            }

            //LL: 28.05.19:
            //  if dataTypeInObj is time, values are time-date-strings ("1899-12-31T16:03:00"),
            //                it is DateTimeFunctions.TimeValueFormat = 'yyyy-MM-ddTHH:mm:ss'
            //  but "value" is "03:30:00"
            let values = colorIntervals.values;

            if (isTypeOfTime(dataTypeInObj)) {
                values = _.map(values, (dateString: string) => {
                    dateString = convertTimeValueAsDateToString(dateString);
                    return dateString;
                });
            }

            //    { labels:[], values:[] }   labels are colors   labels.len = values.len + 1
            let color: any;

            for (var i = 0; i < values.length; i++) {
                if (valueString < values[i]) {
                    color = colorIntervals.labels[i];
                    break;
                }
            }
            if (color == null) {
                color = colorIntervals.labels[colorIntervals.labels.length - 1];
            }

            return color;
        } else {
            // not discrete
            //LL: temp only for numeric:
            if (!(dataType == null || dataType === 'i' || dataType === 'r' || dataType === 'number')) {
                return null;
            }
        }

        var log10 = function (num) {
            if (num === 0) {
                return 0;
            }

            var lg = num > 0 ? Math.log(num) : -Math.log(-num);

            return lg / Math.LN10;
        };

        var evaluateColorPart = function (deltaR, minR) {
            //LL: deltaR may be negative
            var r = ((v - minV) * deltaR) / delta;
            //  ff -> b7, deltaR = -72 = -x48, v = 1, delta = 4
            //  dr * 1/4 = 18 = x12
            r = Math.round(r);
            r = minR + r;
            return r;
        };

        // - values scale:

        var v = value;
        var minV = minValue;
        var maxV = maxValue;
        if (cmfnObj.scaleAuto != true) {
            minV = cmfnObj.scaleMin;
            maxV = cmfnObj.scaleMax;
        }
        //console.log("  === evaluateColor: minV = " + minV + " maxV = " + maxV);

        const toLg = cmfnObj.mapping === 'logarithmic' || cmfnObj.mapping === 'Logarithmic';

        if (toLg) {
            v = log10(v);
            minV = log10(minV);
            maxV = log10(maxV);
            //console.log("  === evaluateColor toLg: minV = " + minV + " maxV = " + maxV + ' v = ' + v);
        }

        // - colors scale:
        var minColor = cmfnObj.startColor;
        var maxColor = cmfnObj.endColor;

        // - evaluate:
        var oMax = ColorHexWrapper.hexToRgb(maxColor); // { r:, g:, b: }
        var oMin = ColorHexWrapper.hexToRgb(minColor);

        var oDelta = {
            r: oMax.r - oMin.r,
            g: oMax.g - oMin.g,
            b: oMax.b - oMin.b
        };
        var delta = maxV - minV;

        var vColor;

        if (typeof v === 'number') {
            if (v <= minV) {
                vColor = minColor;
            } else if (v >= maxV) {
                vColor = maxColor;
            } else {
                var r = evaluateColorPart(oDelta.r, oMin.r);
                var g = evaluateColorPart(oDelta.g, oMin.g);
                var b = evaluateColorPart(oDelta.b, oMin.b);

                vColor = ColorHexWrapper.rgbToHex(r, g, b);
            }
            //console.log("  === evaluateColor: vColor = " + vColor);
        }
        return vColor;
    }
}

//LL: 01.09.20: Color lib (color.js) does not deal with color names
//LL:  see https://stackoverflow.com/questions/8027423/how-to-check-if-a-string-is-a-valid-hex-color-representation/8027444
//  to get the RGBA values of a "color" in any of the formats --be it 'green', or '#FFF', or '#89abcd', or 'rgb(0,0,128)', or 'rgba( 0, 128, 255, 0.5)'.
/* getRGBA:
 Get the RGBA values of a color.
 If input is not a color, returns NULL, else returns an array of 4 values:
 red (0-255), green (0-255), blue (0-255), alpha (0-1)
 */
function getRGBA(value) {
    // get/create a 0 pixel element at the end of the document, to use to test properties against the client browser
    var e = document.getElementById('test_style_element');

    if (e == null) {
        e = document.createElement('span');
        e.id = 'test_style_element';
        e.style.width = '0'; // 0;
        e.style.height = '0'; // 0;
        e.style.borderWidth = '0'; // 0;
        document.body.appendChild(e);
    }

    // use the browser to get the computed value of the input
    e.style.borderColor = '';
    e.style.borderColor = value;

    if (e.style.borderColor == '') {
        return null;
    }

    var computedStyle = window.getComputedStyle(e);
    var c;

    if (typeof computedStyle.borderBottomColor != 'undefined') {
        // as always, MSIE has to make life difficult
        c = window.getComputedStyle(e).borderBottomColor;
    } else {
        c = window.getComputedStyle(e).borderColor;
    }

    var numbersAndCommas = c.replace(new RegExp('[^0-9.,]+', 'g'), '');
    var values = numbersAndCommas.split(',');

    for (var i = 0; i < values.length; i++) {
        values[i] = Number(values[i]);
    }

    if (values.length == 3) {
        values.push(1);
    }

    return values;
}
//LL: 01.09.20:
export function isStringValidColor(s) {
    if (typeof s === 'string') {
        let colorValArray = getRGBA(s);
        return colorValArray != null;
    }
    return false;
}

//OE: Create React or native CSS style from our cellStyle structure
//LL: 20.11.20: add attrRefer, dataSourceID - needed for AttributeMapping
export function makeInlineStyleReact(
    cellStyle: ICellStyle,
    theme: IValuesCollection,
    value: any,
    attrRefer?: string,
    dataSourceID?: number,
    minValue?,
    maxValue?
): React.CSSProperties {
    let style: React.CSSProperties = null;

    //LL: 18.11.20:
    //    add foreground_mappingName, foreground_mappingType; background_mappingName, background_mappingType
    //    foregroundColorSchema, backgroundColorSchema remain for compatibility
    //    type MappingType = 'DiscreteMapping' | 'ColorScale' | 'AttributeMapping';   (in IntervalsSelect)
    if (cellStyle != null) {
        style = {};

        let foreColor;
        let backColor;

        //LL: 20.11.20: add attrRefer, dataSourceID - needed for AttributeMapping
        let colorAttributeMappingObj: any;

        if (
            cellStyle.foreground_mappingType === 'AttributeMapping' ||
            cellStyle.background_mappingType === 'AttributeMapping'
        ) {
            if (attrRefer != null && dataSourceID != null) {
                let colorMappings = theme[themeVars.entityAttributeMapping];
                let cmObj = _.find(colorMappings, function (cm: any) {
                    return cm.dataSourceID === dataSourceID && cm.attribute === attrRefer;
                });

                if (cmObj != null) {
                    colorAttributeMappingObj = cmObj.colorMap;
                }
            }
        }

        //  -- fore color:
        if (cellStyle.foregroundColor != null) {
            foreColor = cellStyle.foregroundColor;
        }
        //LL: OLD:
        if (cellStyle.foregroundColorSchema != null && cellStyle.foregroundColorSchema !== 'none') {
            const schemaObj = MappingUtilities.getMappingSchema(
                theme[themeVars.color_scales_set],
                cellStyle.foregroundColorSchema
            );
            if (schemaObj != null) {
                foreColor = ColorHexWrapper.evaluateColor(value, minValue || 0, maxValue || 100, schemaObj);
            }
        }
        //LL: 18.11.20:
        if (cellStyle.foreground_mappingName != null && cellStyle.foreground_mappingName !== 'none') {
            if (cellStyle.foreground_mappingType === 'DiscreteMapping') {
                let colorMappingObj = MappingUtilities.getMappingSchema(
                    theme[themeVars.discreteMapping_set],
                    cellStyle.foreground_mappingName
                );
                if (colorMappingObj != null) {
                    let vColor = MappingUtilities.evaluateDiscreteMapping(value, colorMappingObj);
                    if (vColor != null) {
                        foreColor = vColor;
                    }
                }
            } else if (cellStyle.foreground_mappingType === 'ColorScale') {
                let colorMappingObj = MappingUtilities.getMappingSchema(
                    theme[themeVars.color_scales_set],
                    cellStyle.foreground_mappingName
                );
                if (colorMappingObj != null) {
                    let vColor = ColorHexWrapper.evaluateColor(value, minValue || 0, maxValue || 100, colorMappingObj);
                    if (vColor != null) {
                        foreColor = vColor;
                    }
                }
            }
            //LL: 20.11.20:
            else if (cellStyle.foreground_mappingType === 'AttributeMapping') {
                if (colorAttributeMappingObj != null) {
                    let vColor = colorAttributeMappingObj[value];
                    if (vColor == null) {
                        vColor = colorAttributeMappingObj[COLOR_MAP_UNDEF_KEY];
                    }
                    if (vColor == null) {
                        vColor = COLOR_MAP_UNDEF_COLOR;
                    }
                    if (vColor != null) {
                        foreColor = vColor;
                    }
                }
            }
        }
        if (foreColor != null) {
            style.color = foreColor;
        }

        //  -- back color:
        if (cellStyle.backgroundColor != null) {
            backColor = cellStyle.backgroundColor;
        }
        //LL: OLD:
        if (cellStyle.backgroundColorSchema != null && cellStyle.backgroundColorSchema !== 'none') {
            const schemaObj = MappingUtilities.getMappingSchema(
                theme[themeVars.color_scales_set],
                cellStyle.backgroundColorSchema
            );
            if (schemaObj != null) {
                backColor = ColorHexWrapper.evaluateColor(value, minValue || 0, maxValue || 100, schemaObj);
            }
        }
        //LL: 18.11.20:
        if (cellStyle.background_mappingName != null && cellStyle.background_mappingName !== 'none') {
            if (cellStyle.background_mappingType === 'DiscreteMapping') {
                let colorMappingObj = MappingUtilities.getMappingSchema(
                    theme[themeVars.discreteMapping_set],
                    cellStyle.background_mappingName
                );
                if (colorMappingObj != null) {
                    let vColor = MappingUtilities.evaluateDiscreteMapping(value, colorMappingObj);
                    if (vColor != null) {
                        backColor = vColor;
                    }
                }
            } else if (cellStyle.background_mappingType === 'ColorScale') {
                let colorMappingObj = MappingUtilities.getMappingSchema(
                    theme[themeVars.color_scales_set],
                    cellStyle.background_mappingName
                );
                if (colorMappingObj != null) {
                    let vColor = ColorHexWrapper.evaluateColor(value, minValue || 0, maxValue || 100, colorMappingObj);
                    if (vColor != null) {
                        backColor = vColor;
                    }
                }
            }
            //LL: 20.11.20:
            else if (cellStyle.background_mappingType === 'AttributeMapping') {
                if (colorAttributeMappingObj != null) {
                    let vColor = colorAttributeMappingObj[value];
                    if (vColor == null) {
                        vColor = colorAttributeMappingObj[COLOR_MAP_UNDEF_KEY];
                    }
                    if (vColor == null) {
                        vColor = COLOR_MAP_UNDEF_COLOR;
                    }
                    if (vColor != null) {
                        backColor = vColor;
                    }
                }
            }
        }
        if (backColor != null) {
            style.backgroundColor = backColor;
        }

        if (cellStyle.fontFace != null) {
            style.fontFamily = cellStyle.fontFace;
        }
        if (cellStyle.fontSize != null) {
            style.fontSize = cellStyle.fontSize;
        }
        if (cellStyle.fontWeight != null) {
            style.fontWeight = cellStyle.fontWeight as any;
        }
        if (cellStyle.fontItalic === true) {
            style.fontStyle = 'italic';
        }
    }

    return style;
}

//LL: 20.11.20: add attrRefer, dataSourceID - needed for AttributeMapping
export function makeInlineStyleCSS(
    cellStyle: ICellStyle,
    themeObj: IValuesCollection,
    value,
    attrRefer,
    dataSourceID,
    minValue?,
    maxValue?
): string {
    //LL: 20.11.20: add attrRefer, dataSourceID - needed for AttributeMapping
    const ReactStyle = makeInlineStyleReact(cellStyle, themeObj, value, attrRefer, dataSourceID, minValue, maxValue);

    if (ReactStyle != null) {
        const json = JSON.stringify(ReactStyle);
        const cssStyle = json
            .replace('backgroundColor', 'background-color')
            .replace('fontFamily', 'font-family')
            .replace('fontWeight', 'font-weight')
            .replace('fontSize', 'font-size')
            .replace('fontStyle', 'font-style')
            .replace(/","/g, '";"') // VR: here was a wrong replacement: "BB":"xx","FF":"rgb(1, 2, 3)" to "BB":"xx";"FF":"rgb(1; 2; 3)". So, rgb() and whole style failed!
            .replace(/\"/g, '')
            .replace('{', '')
            .replace('}', '');
        return cssStyle;
    }
    //VR: see WorkItem [111734]: Color Mapping with new rgb() schema is not applied in Grid etc = BUG

    return null;
}

//LL: 20.11.20: add attrRefer, dataSourceID - needed for AttributeMapping
export function makeInlineStyleJQuery(
    cellStyle: ICellStyle,
    themeObj: IValuesCollection,
    value,
    attrRefer,
    dataSourceID,
    minValue?,
    maxValue?
): Object {
    //LL: 20.11.20: add attrRefer, dataSourceID - needed for AttributeMapping
    const ReactStyle = makeInlineStyleReact(cellStyle, themeObj, value, attrRefer, dataSourceID, minValue, maxValue);

    if (ReactStyle != null) {
        const json = JSON.stringify(ReactStyle);
        const cssStyle = json
            .replace('backgroundColor', 'background-color')
            .replace('fontFamily', 'font-family')
            .replace('fontWeight', 'font-weight')
            .replace('fontSize', 'font-size')
            .replace('fontStyle', 'font-style');

        return JSON.parse(cssStyle);
    }

    return {};
}

export class JsonTraverse {
    static traverse(obj, callback) {
        if (_.isArray(obj)) {
            JsonTraverse.traverseArray(obj, callback);
        } else if (_.isObject(obj)) {
            JsonTraverse.traverseObject(obj, callback);
        } else {
            callback(obj);
        }
    }

    static traverseArray(arr, callback) {
        _.each(arr, (el) => {
            JsonTraverse.traverse(el, callback);
        });
    }

    static traverseObject(obj, callback) {
        callback(obj);
        for (var key in obj) {
            if (obj != null && obj.hasOwnProperty(key)) {
                JsonTraverse.traverse(obj[key], callback);
            }
        }
    }
}

function elemNormalize_DataSourceNameToID(el, prop, glob: IGlob) {
    if (el.hasOwnProperty(prop)) {
        const ID = glob.AttrQueryStore.getDataSourceIDByName(el[prop]);

        if (ID != null) {
            el[prop] = ID;
        }
    }
}

export function jsonNormalize_DataSourceNameToID(data, glob: IGlob) {
    JsonTraverse.traverse(data, (el) => {
        if (el != null) {
            elemNormalize_DataSourceNameToID(el, 'dataSourceID', glob);
            elemNormalize_DataSourceNameToID(el, 'dataSourceID1', glob);
        }
    });
}

function elemNormalize_DataSourceIDToName(el, prop, glob: IGlob) {
    if (el.hasOwnProperty(prop)) {
        const name = glob.AttrQueryStore.getDataSourceNameByID(el[prop]);

        if (name != null) {
            el[prop] = name;
        }
    }
}

export function jsonNormalize_DataSourceIDToName(data, glob: IGlob) {
    JsonTraverse.traverse(data, (el) => {
        if (el != null) {
            elemNormalize_DataSourceIDToName(el, 'dataSourceID', glob);
            elemNormalize_DataSourceIDToName(el, 'dataSourceID1', glob);
        }
    });
}

//---------------------------------------------------------------------

function elemNormalize_ThemeNameToID(el, prop, glob: IGlob) {
    if (el.hasOwnProperty(prop)) {
        const themesData = glob.ThemeStore.getThemesHash();
        const ids = [];

        for (let index = 0; index < el[prop].length; index++) {
            const name = el[prop][index];
            const obj = _.find(themesData, { name: name });

            if (obj && obj.id) {
                ids.push(obj.id);
            }
        }

        if (ids.length > 0) {
            el[prop] = ids;
        }
    }
}

function elemNormalize_ThemeIDToName(el, prop, glob: IGlob) {
    if (el.hasOwnProperty(prop)) {
        const themesData = glob.ThemeStore.getThemesHash();
        const names = [];

        for (let index = 0; index < el[prop].length; index++) {
            const id = el[prop][index];
            const obj = _.find(themesData, { id: id });

            if (obj && obj.name) {
                names.push(obj.name);
            }
        }

        if (names.length > 0) {
            el[prop] = names;
        }
    }
}

export function jsonNormalize_ThemeNameToID(data, glob: IGlob) {
    JsonTraverse.traverse(data, (el) => {
        if (el != null) {
            elemNormalize_ThemeNameToID(el, '_keys', glob);
        }
    });
}

export function jsonNormalize_ThemeIDToName(data, glob: IGlob) {
    JsonTraverse.traverse(data, (el) => {
        if (el != null) {
            elemNormalize_ThemeIDToName(el, '_keys', glob);
        }
    });
}
//-------------------------------------------------------------------------

export function explainAttributeType(attributeType: string) {
    switch (attributeType) {
        case ATTRIBUTE_TYPES.INTEGER:
            return 'Integer';

        case ATTRIBUTE_TYPES.BIGINT:
            return 'Big Integer';

        case ATTRIBUTE_TYPES.REAL:
            return 'Decimal';

        case 'number':
            return 'Number';

        case ATTRIBUTE_TYPES.BOOLEAN:
        case 'boolean':
            return 'Boolean';

        case ATTRIBUTE_TYPES.STRING:
        case 'string':
            return 'String';

        case ATTRIBUTE_TYPES.DATE:
            return 'Date';

        case ATTRIBUTE_TYPES.DATETIME:
            return 'DateTime';

        case ATTRIBUTE_TYPES.TIME:
            return 'Time';

        case ATTRIBUTE_TYPES.ANYTYPE:
            return 'Any';

        default:
            return attributeType;
    }
}

export function stringToValue(valueText: string, attributeType: string) {
    switch (attributeType) {
        case ATTRIBUTE_TYPES.INTEGER:
            return parseInt(valueText);

        case ATTRIBUTE_TYPES.REAL:
            return parseFloat(valueText);

        case 'number':
            return parseFloat(valueText);

        case ATTRIBUTE_TYPES.BOOLEAN:
        case 'boolean':
            return JSON.parse(valueText);

        case ATTRIBUTE_TYPES.STRING:
        case 'string':
            return valueText;

        case ATTRIBUTE_TYPES.DATE:
            return new Date(valueText);

        case ATTRIBUTE_TYPES.DATETIME:
            return new Date(valueText);

        case ATTRIBUTE_TYPES.TIME:
            return valueText;

        case ATTRIBUTE_TYPES.ANYTYPE:
            return valueText;

        default:
            return valueText;
    }
}

// VR, it searched "dataSourceID" in the input string and then it parses it to number:
export function getDataSourceID(text1: string): number {
    //VR: find the first DataSourceID and pass it to CodeField for InteliSense
    let arr1;
    if (text1 != null) {
        arr1 = text1.split('"dataSourceID":');
    }
    if (arr1 != null && arr1[1] != null) {
        let str1 = arr1[1].substring(0, arr1[1].indexOf(','));
        let int1 = parseInt(str1.trim());
        if (isNaN(int1) === false) {
            return int1;
        }
    }
    return null;
}

//Be sure that CKEDITOR_CONFIG_STATIC and 'component' function in mainRouter.ts use the same coding format.
export const CKEDITOR_CONFIG_STATIC = {
    resize_enabled: false,
    browserContextMenuOnCtrl: true,
    filebrowserBrowseUrl:
        '#component/' +
        btoa('pdc-widget-resource-manager/src/ts/react/ResourceBrowser') +
        '/' +
        btoa(JSON.stringify({ mode: 'all', asCKEditExternalBrowser: true })) +
        '/' +
        btoa('Resources'),

    // base64url.encode('pdc-widget-resource-manager/src/ts/react/ResourceBrowser', 'utf8') + '/' +
    // base64url.encode(JSON.stringify({ mode: 'all', asCKEditExternalBrowser: true }), 'utf8') + '/' +
    // base64url.encode('Resources', 'utf8')
    filebrowserImageBrowseUrl:
        '#component/' +
        btoa('pdc-widget-resource-manager/src/ts/react/ResourceBrowser') +
        '/' +
        btoa(JSON.stringify({ mode: 'image', asCKEditExternalBrowser: true })) +
        '/' +
        btoa('Resources'),

    // base64url.encode('pdc-widget-resource-manager/src/ts/react/ResourceBrowser', 'utf8') + '/' +
    // base64url.encode(JSON.stringify({ mode: 'image', asCKEditExternalBrowser: true }), 'utf8') + '/' +
    // base64url.encode('Resources', 'utf8')
    filebrowserWindowWidth: '900',
    filebrowserWindowHeight: '640',
    removePlugins: 'image,resize, maximize',
    extraPlugins: 'image2,pdc-maximize,pdc-resource-manager'
};

export function parseBooleanCustomFormat(value: string) {
    let result = {
        _true: 'True',
        _false: 'False'
    };

    if (value != null) {
        try {
            result = JSON.parse(value);
        } catch (e) {}
    }

    return result;
}

export function renderTemplate(template: string, data: { [key: string]: any }) {
    if (template.search('<%') !== -1) {
        template = template.replace('<p>', '').replace('</p>', '').replace('\n', '');
        template = template.replace(/<%([^~][\s\S]*?)%>/g, (str, val) => {
            val.trim();
            return '<%' + val.trim().replace(/\s/g, '_') + '%>';
        });

        const templateFunc = _.template(template, {
            interpolate: /<%([^~][\s\S]*?)%>/g,
            evaluate: /<%~([\s\S]+?)%>/g
        });

        const inputData = {};

        _.each(data, (value, key) => {
            if (key != null && key.length > 0) {
                key = key.trim().replace(/\s/g, '_');

                if (key.length > 0) {
                    inputData[key] = value || '';
                }
            }
        });

        let result: string;

        try {
            result = templateFunc(inputData);
        } catch (e) {
            result = 'Wrong Template: ' + e.message;
        }

        return result;
    } else {
        return Hogan.compile(template).render(data);
        //return Mustache.to_html(template, data);
    }
}

export function normalizeCustomID(value: string) {
    if (value == null) {
        return undefined;
    }

    let result = value.trim();

    if (result.length === 0) {
        return undefined;
    }

    return result.replace('.', '_');
}

export function makeDefaultCustomID(attribute: string) {
    if (attribute == null) {
        return undefined;
    }

    const attributeParts = attribute.split(ATTRIBUTE_SEPARATOR);

    if (attributeParts.length > 0) {
        return normalizeCustomID(attributeParts[attributeParts.length - 1]);
    }

    return undefined;
}

export function getCSSWidth(value: IWidth) {
    if (value != null) {
        if (typeof value === 'number') {
            return value + 'px';
        }

        if (value.units === 'auto') {
            return 'auto';
        }

        if (value.width != null) {
            const width = typeof value.width !== 'number' ? parseInt(value.width) : value.width;

            if (!isNaN(width) && width > 0) {
                let units: string;

                switch (value.units) {
                    case 'percentage':
                        units = '%';
                        break;

                    case 'rem':
                        units = 'rem';
                        break;

                    default:
                        units = 'px';
                }

                return value.width + units;
            }
        }
    }

    return undefined;
}

export function copyToClipboard(glob: IGlob, linkURL: string, linkText: string) {
    if (navigator.clipboard == undefined) {
        glob.AppActions.showNotification_Fail('Clipboard is not available on Unsecure website.');
        return;
    }

    let isFF = /(Firefox)/i.test(navigator.userAgent);

    if (linkText != null && linkText.length > 0 && !isFF) {
        const HTML = '<a href="' + linkURL + '">' + linkText + '</a>';

        const HBLOB = new Blob([HTML], { type: 'text/html' });
        const PBLOB = new Blob([linkURL], { type: 'text/plain' });

        // Copy the blobs to the clipboard
        navigator.clipboard.write([new ClipboardItem({ 'text/html': HBLOB, 'text/plain': PBLOB })]).then(
            () => glob.AppActions.showNotification_Success('Link to ' + linkText + ' is copied to clipboard'),
            (err) => console.log(err)
        );
    } else {
        navigator.clipboard.writeText(linkURL).then(
            () => glob.AppActions.showNotification_Success('Link to ' + linkURL + ' is copied to clipboard'),
            (err) => console.log(err)
        );
    }
}
